import * as React from 'react';
import { Box, Grid, Link, Typography } from '@mui/material';

import { ZoneCard } from '.';

interface MostActiveZonesProps {}

export const MostActiveZones: React.FC<MostActiveZonesProps> = () => {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-end',
          paddingY: 3,
        }}
      >
        <Typography
          sx={{
            fontWeight: 500,
            lineHeight: 1.1,
          }}
        >
          Most Active Zones
        </Typography>

        <Typography
          variant="caption"
          color="textSecondary"
          sx={{
            lineHeight: 1.2,
            marginLeft: 1,
          }}
        >
          Monthly Views
        </Typography>

        <Link
          component="button"
          variant="subtitle2"
          onClick={() => {}}
          sx={{
            lineHeight: 1.2,
            marginLeft: 'auto',
          }}
        >
          See All
        </Link>
      </Box>

      <Box>
        <Grid container spacing={4}>
          <Grid item xs={4}>
            <ZoneCard />
          </Grid>

          <Grid item xs={4}>
            <ZoneCard />
          </Grid>

          <Grid item xs={4}>
            <ZoneCard />
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
